import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConfigService } from 'app/services/authentication/connection/config.service';
import { environment } from 'environments/environment';

// const URL = environment.webExternalUrl;

@Pipe({
  name: 'webExternalSanitize',
})
export class WebExternalSanitizePipe implements PipeTransform {
  private externalUrl = '';
  constructor(private _sanitizer: DomSanitizer, private _configService: ConfigService) {
    this.externalUrl = this._configService.config.webExternalUrl;
  }

  private baseUrl = 'home/carrier/';
  transform(value: string): SafeResourceUrl {
    const keys = this.storageCarrierToOldAdmin();
    const code = this.encode(JSON.stringify({localStorage: keys}).toString());
    const return_url = this.encode(this.baseUrl+value);
    console.log(`${this.externalUrl}?code=${code}&return_url=${return_url}`);
    return this._sanitizer.bypassSecurityTrustResourceUrl(`${this.externalUrl}?code=${code}&return_url=${return_url}`);
  }

  storageCarrierToOldAdmin(){
    const items = { ...localStorage };
    const keys = {};
    Object.keys(items).forEach((key:string)=>{
      if (key.includes('carrier')) {
        const newKey = key.substring(8);
        keys[Number(newKey)]=items[key];
      }
    });
    return keys;
  }

  encode(value:string){
    return btoa(encodeURI( value ));
  }
}
